import { sum } from '../utils/Array'
import '../utils/Map'
import { ParsedItem } from './ItemParser'

const sumAsteroidTypes = (items: Array<ParsedItem>): Array<ParsedItem> =>
  items.groupBy(item => item.name).toList().map(e => e[1]).map(collapse(items))

const collapse = (allItems: Array<ParsedItem>) => (items: Array<ParsedItem>): ParsedItem => ({
  name: items[0].name,
  count: sum(items.map(i => i.count)),
  volume: sum(items.map(i => i.volume as number)),
  ratio: sum(items.map(i => i.volume as number)) / sum(allItems.map(i => i.volume as number))
})

export { sumAsteroidTypes }
